import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import type { HubGuideCompanionProps } from "@/types/help-hub/presentation";
import { hubBrandTheme } from "../brandInk";
import { HubAskBox } from "./HubAskBox";
import { GenieIcon } from "@/components/ui/genie-icons/GenieIcon";

export const HubGuideCompanion = ({ guide, branding, displayName, hubHref, onAsk, onTalk }: HubGuideCompanionProps) => {
  const theme = hubBrandTheme(branding);
  return (
    <aside className="hub-guide-companion" aria-label="Help with this guide">
      <GenieIcon name="genie-lamp" size={32} color={theme.primary} secondaryColor={theme.secondary} gradientEnabled={theme.gradientOn} label="" />
      <h2>A little help,<br />right beside you.</h2>
      <p>Ask {displayName} a question while you read, or talk through what you need.</p>
      <p className="hub-guide-context">Reading: {guide.name}</p>
      <HubAskBox branding={branding} placeholder="Ask about this guide…" onAsk={question => onAsk(`About the guide "${guide.name}": ${question}`)} onTalk={onTalk} />
      {!!guide.genieDocument?.sections.length && <nav className="hub-guide-outline" aria-label="In this guide"><h3>In this guide</h3>{guide.genieDocument.sections.map((section, index) => <a href={`#guide-section-${index + 1}`} key={index}><span>{String(index + 1).padStart(2, "0")}</span>{section.heading}</a>)}</nav>}
      <Link to={`${hubHref}#ways-in`} className="hub-guide-help-link">All the ways to reach us <ArrowRight className="h-4 w-4" /></Link>
    </aside>
  );
};
